import React, { useState, FC, useEffect, useContext } from 'react';
import { useSelector, useDispatch  } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Card, Typography, Button, Container, Grid, IconButton } from '@material-ui/core';
import { utilities } from '../../helpers/utilities';
import * as Validations from "../../helpers/validations";

//imports
import { AddressReducerState} from "../../flux/reducers/deliveryAddress-reducer";
import { addAddressAction, verifyZipAction, getAddressAction } from "../../flux/actions/deliveryAddress-actions";
import UserModel from '../../models/user-model';
import TextFieldComponent from "../../components/TextFieldComponent";
import Title from "../../components/Title";
import SubTitle from "../../components/STitle"; 
import ScreenLoader from "../../components/ScreenLoader";
import ButtonComponent from "../../components/ButtonComponent";
import SelectComponent from '../../components/SelectComponent';
import SnackBarAlert from '../../components/SnackBar/SnackBarAlert';
import { AppContext } from '../OrderFlux/Context';

import { useStyles } from "./styles";
import ArrowBack from '@material-ui/icons/ArrowBack';


const AddAddress: FC = () => {
  const { handleNext, handleBack } = useContext(AppContext);
  const history = useHistory();
  
  //initialize styles
  const classes = useStyles();
  
  //User information
  const user: UserModel = useSelector((state: any) => state.authReducer.user)
  const cart = useSelector((state: any) => state.cart);
  const { cartItems } = cart;

  //Variables
  const dispatcher = useDispatch();
  const [name, setName] = useState(user.full_name ?? '');  
  const [cp, setCp] = useState("");
  const [phoneNumber, setPhoneNumber] = useState(user.phone ?? '');
  const [city, setCity] = useState("");
  const [street, setStreet] = useState("");
  const [email, setEmail] = useState(user.email);
  const [district, setDistrict] = useState<string>("");
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [firstLoad, setFirstLoad] = useState(false);
  const [districts, setDistricts] = useState<string[]>([]);
  const [errorMessage, setErrorMessage] = useState("")
  const [errors, setErrors] = useState({ cp: "", city: "", street:"", name: "", email: "", phoneNumber: "", district: "" });
  
  const addAddressState: AddressReducerState = useSelector(
    (state: any) => state.addAddressReducer
  );

  useEffect(() => {
    setLoading(addAddressState.loading)
  }, [addAddressState.loading]);

  useEffect(() => {
    if (!user.id) {
      history.push('/login?redirect=checkoutprocess');
    }
  }, [history, user.id]);
  
  useEffect(() => { 
    dispatcher(getAddressAction(user.id));
    setLoading(false);
    setErrorMessage("");
    setErrors({ cp: "", city: "", street: "", name: "", email: "", phoneNumber : "", district: ""});
  }, [])

  useEffect(() => { 
    if(addAddressState.addressResponse){
      setDistrict(addAddressState.addressResponse.district);
      setName(addAddressState.addressResponse.name);
      setEmail(addAddressState.addressResponse.email);
      setPhoneNumber(addAddressState.addressResponse.phone);
      setCity(addAddressState.addressResponse.city);
      setStreet(addAddressState.addressResponse.street);
      setCp(addAddressState.addressResponse.cp);
      setFirstLoad(false);
      addAddressState.addressResponse.cp && dispatcher(verifyZipAction(addAddressState.addressResponse.cp));
    } else {
      setName(user.full_name);
      setEmail(user.email);
      setPhoneNumber(user.phone ?? '');
      setCp('');
      setCity('');
      setDistrict('');
      setStreet('');
    }
  }, [addAddressState.addressResponse])

  useEffect(() => { 
    if (addAddressState.errorMessage) {
      setErrorMessage(addAddressState.errorMessage);
    }
  }, [addAddressState.errorMessage])

  useEffect(() =>{
    const zipResponse = addAddressState.zipCodeResponse;
    var auxDistricts:string[] = [];

    if (zipResponse!=null && cp) {
      if(zipResponse[0].ciudad === 'Morelia'){

        for (var response of zipResponse) {
          auxDistricts.push(response.nombre);
        }

        setCity(zipResponse[0].ciudad)
        setDistricts(auxDistricts);
        setDistrict(auxDistricts[0]);
        setDisabled(false);

      } else {
        setErrors({
          ...errors,
          cp: "Sólo envíos dentro de Morelia",
        });
      }
    }
  }, [addAddressState.zipCodeResponse])
  
  const validateZip = () => {
    dispatcher(verifyZipAction(cp));    
  }

  const onKeyPressCp = (event: React.KeyboardEvent) => {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  }

  //Add address to the data base
  const postAddress = () => {
    const cpErrors = Validations.validate([Validations.required], cp);
    const districtErrors = Validations.validate([Validations.required], district);
    const streetErrors = Validations.validate([Validations.required, Validations.maxLength250], street);
    const nameErrors = Validations.validate([Validations.required, Validations.maxLength50], name);
    const emailErrors = Validations.validate([Validations.required, Validations.emailText, Validations.maxLength50], email);
    const phoneNumberErrors = Validations.validate([Validations.required, Validations.maxLength10, Validations.minLength10], phoneNumber);

    setErrors({
      ...errors,
      cp: cpErrors,
      district: districtErrors,
      street: streetErrors,
      name : nameErrors,
      email : emailErrors,
      phoneNumber : phoneNumberErrors 
    });
    
    if (!nameErrors && !emailErrors && !phoneNumberErrors && !cpErrors && !streetErrors && !districtErrors) {
      dispatcher(
        addAddressAction({
          cp: cp,
          city: city,
          district: district.trim(),
          street: street.trim(),
          userRef: user.id,
          name : name.trim(),
          email : email.trim(),
          phone : phoneNumber.trim()
        })
      );
      const temporalAddress = {
        cp: cp,
        city: city,
        district: district.trim(),
        street: street.trim(),
        userRef: user.id,
        name : name.trim(),
        email : email.trim(),
        phone : phoneNumber.trim()
      }
      localStorage.setItem('clientAddress', JSON.stringify(temporalAddress));
    }
  }

  useEffect(() => {
    if (
      addAddressState.success 
      && !errors.cp 
      && !errors.city 
      && !errors.street 
      && !errors.phoneNumber 
      && !errors.email 
      && !errors.name
    ) {
      handleNext();
    }
  }, [addAddressState.success]);

  return (
    <Container component="main" fixed>
      <div className={classes.header}>
        <IconButton onClick={handleBack}>
          <ArrowBack className='arrowBack' />
        </IconButton>
        <h1 className='title'>Datos de Envío</h1>
      </div>
      <Grid container direction="row">
        <Grid item className={classes.section}>
          <Grid container spacing={2}  className={classes.bodySection}>
            <Grid item>
              <ScreenLoader isOpen={false} />
              <Title className={classes.title} value="Información de contacto" />
              <SubTitle className={classes.subtitle} value="Ingrese los datos de quien recibe los productos" />
              <TextFieldComponent
                error={utilities.returnErrorFlag(errors.name)}
                helperText={errors.name}
                label={"Nombre"}
                type="text"
                capitalize="default"
                value={name?.replace(/^\s/, '')}
                onChange={(e) => {
                  setName(e.target.value);
                  setErrors({ ...errors, name: ""});
                }}
              />
              <TextFieldComponent
                error={utilities.returnErrorFlag(errors.email)}
                helperText={errors.email}
                label={"Correo"}
                type="email"
                value={email}
                onChange={(e) => {  
                  setEmail(e.target.value);  
                  setErrors({ ...errors, email: ""});        
                }}
              />
              <TextFieldComponent
                error={utilities.returnErrorFlag(errors.phoneNumber)}
                helperText={errors.phoneNumber}
                label={"Teléfono"}
                value={phoneNumber}
                type="number"
                onChange={(e) => { 
                  e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,10)
                  setPhoneNumber(e.target.value);
                  setErrors({ ...errors, phoneNumber: ""});
                }}
              />
            </Grid>
            <Grid  container className={classes.bodySection} >
              <Grid item>
                <Title value="Dirección de Envío" />
                <SubTitle className={classes.subtitle} value="Sólo hacemos envíos dentro de Morelia, por favor valide su código postal" />
                <Grid container>
                  <Grid item xs={6}>
                    <TextFieldComponent
                      error={utilities.returnErrorFlag(errors.cp)}
                      autoComplete="off"
                      helperText={errors.cp}
                      label={"Código Postal"}
                      type="number"
                      value={cp}
                      onChange={(e) => { 
                        e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,5)  
                        setDistrict('');
                        setDistricts([]);
                        setStreet('');
                        setCp(e.target.value);
                        setCity('');
                        setDisabled(true);
                        setErrors({ ...errors, cp: "", city:"", street:""});  
                      }}
                      onKeyPress={onKeyPressCp}
                    />
                  </Grid>
                <Grid item xs={5} className={classes.cpButton}>
                  <ButtonComponent
                    value="Validar CP" 
                    color="secondary" 
                    variant="contained" 
                    onClick={validateZip} 
                    disabled={!cp}
                  />
                </Grid>
              </Grid>
              <Grid container direction="row">
                <Grid item xs={12} md={5}>
                  <TextFieldComponent
                  error={utilities.returnErrorFlag(errors.city)}
                  helperText={errors.city}
                  label={"Ciudad"}
                  type="text"
                  value={city}
                  disabled = {true}
                  onChange={(e) => {               
                    setCity(e.target.value);  
                    setErrors({ ...errors, cp: "", city:"", street:"" });             
                  }}
                  />
                </Grid>
                <Grid item xs={12} md={5} className={classes.cpSelect}>
                  <SelectComponent
                    error={utilities.returnErrorFlag(errors.district)}
                    variableError={errors.district}
                    label={'Colonia'}
                    value={district}
                    disabled={disabled}
                    onChange={(e: any) => {
                      setDistrict(e.target.value as string);
                    }}
                    items={districts ?? []}
                  />
                </Grid>
              </Grid>
              <TextFieldComponent
                error={utilities.returnErrorFlag(errors.street)}
                helperText={errors.street}
                label={"Calle y Número"}
                type="text"
                value={street?.replace(/^\s/, '')}
                disabled = {disabled}
                onChange={(e) => {               
                  setStreet(e.target.value);  
                  setErrors({ ...errors, cp: "", city:"", street:"" });             
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={3} className={classes.orderSummaryContainer}>
        <Card>
          <Typography variant="h5" component="h5" align='center'>
            <span className='total-label'>TOTAL</span>
            <span className='total-price'>${cartItems.reduce((acc: number, product: any) => acc + (product.cost * product.qty), 0).toFixed(2)}</span>
          </Typography>
          <Button 
            variant='contained' 
            color='secondary' 
            size='medium' 
            onClick={postAddress}
          >
            Siguiente
          </Button>
        </Card>
      </Grid>
      </Grid>
      <ScreenLoader
          isOpen={loading}
      />
      { addAddressState.success &&           
          <SnackBarAlert
            message={addAddressState.successMessage ?? ''}
            severity="success"
            open={addAddressState.success}
          /> 
        }
        { addAddressState.errorStatus &&           
          <SnackBarAlert
            message={errorMessage}
            severity="error"
            open={addAddressState.errorStatus}
          /> 
        }
    </Container>
  );
}

export default AddAddress;
